export default __webpack_public_path__ + "static/media/predict.f7bfe94e.svg";